/* tslint:disable */
/* eslint-disable */
/**
 * Etra clearance API
 * Etra clearance API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseRESTEntity
 */
export interface WarehouseRESTEntity {
    /**
     * 
     * @type {number}
     * @memberof WarehouseRESTEntity
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseRESTEntity
     */
    shopId: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseRESTEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseRESTEntity
     */
    lockId: string;
}

export function WarehouseRESTEntityFromJSON(json: any): WarehouseRESTEntity {
    return WarehouseRESTEntityFromJSONTyped(json, false);
}

export function WarehouseRESTEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseRESTEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'shopId': json['shopId'],
        'name': json['name'],
        'lockId': json['lockId'],
    };
}

export function WarehouseRESTEntityToJSON(value?: WarehouseRESTEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'shopId': value.shopId,
        'name': value.name,
        'lockId': value.lockId,
    };
}


